import React, {FC} from 'react';

import {Tailwind} from '../../../../../../Tailwind';
import {CallSchema} from '../../wfReactInterface/wfDataModelHooksInterface';
import {ResultsSection} from './ResultsSection';
import {SummarySection} from './SummarySection';
import {EvalTabDataProvider} from './useEvalTabData';

export const CallEvaluation: FC<{
  call: CallSchema;
}> = ({call}) => {
  return (
    <Tailwind>
      <EvalTabDataProvider call={call}>
        <div>
          <SummarySection />
          <ResultsSection />
          {/* TODO: Pulled usage section in lieu of Summary (*to discuss) */}
          {/* <UsageSection /> */}
        </div>
      </EvalTabDataProvider>
    </Tailwind>
  );
};
